import { api } from "../../helpers/api/handler"

export const unsubscribeTokenless = () => api.get("/auth/unsubscribe/")
